import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ConfigService } from '../../../core/config.service';
import { SubMenuItem } from './sub-menu-item';


@Component({
  selector: 'hb-sub-menu',
  templateUrl: './sub-menu.component.html',
  styleUrls: ['./sub-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SubMenuComponent implements OnInit{

  private curCataLog: string;

  @Input() public subMenuTitle: string;
  @Input() public menuItems: SubMenuItem[] = [];
  @Input() public isSubMenuActive: boolean;
  @Input() public showSubMenu: boolean;
  @Input() public iconClass: string;
  @Input() public navMenuId: string;
  @Output() public openPopupClicked: EventEmitter<SubMenuItem> = new EventEmitter<SubMenuItem>();

  constructor(private readonly configService: ConfigService,  private readonly cdr: ChangeDetectorRef,) {
  }

  public ngOnInit(): void {
    this.configService.selectedCatalog.subscribe(catalog=>{
      if(catalog!==this.curCataLog){
        this.curCataLog = catalog;
        this.cdr.detectChanges();
      }
    });
  }

  public trackMenuItem(_index: number, _item: SubMenuItem): string {
    return _item.route;
  }

  public openPopupClick(item: SubMenuItem): void {
    this.openPopupClicked.emit(item);
  }


}
